import { Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import styled from 'styled-components';

interface LogTableProp {
  header: string[];
  data: (string | number)[][];
}

const Cell = styled(TableCell)`
  border-right: 1px solid black;
  border-bottom: 1px solid black;
  &:last-of-type {
    border-right: none;
  }
  &.${tableCellClasses.head} {
    font-weight: bold;
  }
`;

export default function LogTable({ header, data }: LogTableProp) {
  return (
    <TableContainer sx={{ overflow: 'visible' }}>
      <Table>
        <TableHead>
          <TableRow sx={{ bgcolor: '#A0C1F9' }}>
            {header.map((text) => (
              <Cell key={text}>{text}</Cell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row[0] + row?.[1].toString()}>
              {row.map((text) => {
                return (
                  <Cell key={text} sx={{ whiteSpace: 'pre-line' }}>
                    {text}
                  </Cell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
